import React from 'react';
import Barrier from "../../../components/pages/form/Barrier/Barrier";

const BarrierPage = () => {
    return <Barrier />
};

export default BarrierPage;
